import React from 'react';

export function LoadingState() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050505] px-4 py-16">
      <main className="w-full max-w-2xl rounded-lg bg-gray-900 p-8 shadow-lg border border-gray-800">
        <div className="text-center">
          <p className="text-gray-300">Loading squad...</p>
        </div>
      </main>
    </div>
  );
}
